/* eslint-disable react/no-unknown-property */
import { graphql, useStaticQuery } from 'gatsby';
import React, { useEffect } from 'react';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  widgetID?: string | null;
  sku?: string;
}

const Widget = function ({ widgetID = null, sku = '', className, ...rest }: Props) {
  useEffect(() => {
    if (typeof window !== 'undefined' && window?.PriceSpider?.debouncedRebind) {
      window?.PriceSpider?.debouncedRebind();
    }
  }, []);

  const pluginData = useStaticQuery(graphql`
    query {
      sitePlugin(name: { eq: "gatsby-plugin-pricespider" }) {
        pluginOptions
      }
    }
  `);
  const { defaultWidgetID } = pluginData.sitePlugin.pluginOptions;

  /**
   * This causes server hydration issues atleast with DEV_SSR.
   * where the server does not expect a span to be added to a div.
   * this seems to be a bug withing pricespider.
   *
   * So far no major issues have been caused by allowing this hydration error other then possible
   * performance issues since it will opt pages its on out of ssr.
   *
   * Though no console warnings appear on dev or prod. Could also be a bug with DEV_SSR.
   **/
  return (
    <div
      className={`ps-widget ${className}`}
      ps-sku={sku}
      ps-config={widgetID || defaultWidgetID}
      {...rest}
    />
  );
};

export default Widget;
